import {css} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {NODE_SECTION_SUMMARIES_STYLES, noDragClass} from '../BenchlingNodeDesignConstants';
import {NodeSection} from '../BenchlingNodeTypes';

/**
 * Section summaries for the BenchlingNode.
 * If hideSectionSummaries is true, this component will not render anything.
 * Otherwise will render all section summaries, including those that are hidden.
 * Exported for use with BenchlingNode.
 */
export function BenchlingNodeSectionSummaries<TRowData>(props: {
  data: {
    hideSectionSummaries?: boolean;
    sections: Array<NodeSection<TRowData>>;
  };
}): JSX.Element | null {
  if (props.data.hideSectionSummaries || props.data.sections.length === 0) {
    return null;
  }
  const noVisibleSections =
    props.data.sections.filter((section: NodeSection<TRowData>) => !section.hideSection).length === 0;

  return (
    <div
      className={noDragClass(
        css(
          NODE_SECTION_SUMMARIES_STYLES.sectionSummaries,
          noVisibleSections && NODE_SECTION_SUMMARIES_STYLES.sectionSummariesBorder
        )
      )}
      {...getTestProps({
        component: 'BenchlingNodeSectionSummaries',
        element: 'root',
      })}
    >
      {props.data.sections.map((section: NodeSection<TRowData>, index: number) => (
        <div
          key={`${section.sectionName}-${index}`}
          className={css(NODE_SECTION_SUMMARIES_STYLES.sectionSummary)}
          {...getTestProps({
            component: 'BenchlingNodeSectionSummaries',
            element: 'sectionSummary',
            key: section.sectionName,
          })}
        >
          <BenchlingIcon
            className={css(NODE_SECTION_SUMMARIES_STYLES.sectionSummaryIcon)}
            icon={section.sectionIcon ?? 'circle-question'}
            {...getTestProps({
              component: 'BenchlingNodeSectionSummaries',
              element: 'sectionIcon',
            })}
          />
          <div
            className={css(NODE_SECTION_SUMMARIES_STYLES.sectionSummaryCount)}
            {...getTestProps({
              component: 'BenchlingNodeSectionSummaries',
              element: 'sectionRowCount',
            })}
          >
            {section.sectionRows.length}
          </div>
        </div>
      ))}
    </div>
  );
}
